import { number, string } from "prop-types";
import { useRef, useState } from "react";

import { PREPARING_EXPORT } from "Flocknote/GlobalComponents/Modal/contentKeys";
import { useNetworkMetadata } from "Flocknote/apiHooks";
import flocknoteStateHooks from "Flocknote/stateHooks";

import API from "../API";

import BoardButton from "./BoardButton";
import ButtonTooltip from "./ButtonTooltip";

ExportButton.propTypes = {
  boardID: number.isRequired,
  groupURL: string,
  savedFilterRequestID: number,
};

export default function ExportButton({
  boardID,
  groupURL,
  savedFilterRequestID,
}) {
  const buttonRef = useRef();
  const [showTooltip, setShowTooltip] = useState(false);
  const [, { openModal }] = flocknoteStateHooks.useModal();
  const [{ hasQueuedExports }] = useNetworkMetadata();

  const exportBoard = () => {
    const filters = window.fnReactBus.getCurrentFilterRequest();

    if (!filters) {
      if (hasQueuedExports) {
        // No filters in place, so just generate the file
        prepareExport();
      } else {
        return window.open(`/board/${boardID}/export?groupURL=${groupURL}`);
      }
    } else {
      // Since there are filters in place, we need to use the API to generate a filterRequestID
      API.getExportFilterRequestID({ groupURL, filters, savedFilterRequestID })
        .post()
        .then((res) => {
          // generate the file but within context of the filterRequestID
          if (hasQueuedExports) {
            prepareExport(res.filterRequestID);
          } else {
            return window.open(
              `/board/${boardID}/export?filterRequestID=${res.filterRequestID}&groupURL=${groupURL}&savedFilterRequestID=${savedFilterRequestID}`
            );
          }
        })
        .catch((err) => {
          console.error(
            "Error trying to export with filter, exporting the whole report instead!",
            err
          );
          prepareExport();
        });
    }
  };

  const prepareExport = (filterRequestID) => {
    API.triggerExport({
      filterRequestID,
      boardID,
      groupURL,
      savedFilterRequestID,
    })
      .post()
      .then((res) => {
        if (res.success) {
          openModal(PREPARING_EXPORT, { exportID: res.exportID });
          window.checkBackgroundJobs();
        }
      })
      .catch((err) => {
        console.error("Error trying to export with filter", err);
      });
  };

  return (
    <>
      <BoardButton
        ref={buttonRef}
        data-cy="exportBoardSheetButton"
        onClick={exportBoard}
        className="fas fa-file-spreadsheet"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      />
      <ButtonTooltip
        show={showTooltip}
        buttonRef={buttonRef}
        content="Export Report"
      />
    </>
  );
}
